import type { Moment } from 'moment';
import { FixtureTypes } from './constants';
import { Values } from './objectEnums';
import { toMoment } from './date';
import getActualRedeliveryDate from './getActualRedeliveryDate';

type VoyageHireCapFields = Parameters<typeof getActualRedeliveryDate>[0] & {
	estRedeliveryDate?: Moment | string | null;
};

const getHireCapDate = (
	voyage: VoyageHireCapFields,
	fixtureType: Values<typeof FixtureTypes> | null | undefined,
): Moment | null => {
	if (fixtureType === FixtureTypes.TC_OUT && voyage.estRedeliveryDate != null) {
		return toMoment(voyage.estRedeliveryDate);
	}

	return getActualRedeliveryDate(voyage);
};

export default getHireCapDate;
